"use client";

import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Separator } from "@/components/ui/separator";
import { Facebook, Instagram, Linkedin, Music, Youtube, MessageCircle, Radio } from "lucide-react";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-2">
        <div className="h-4 w-24 bg-muted/20 animate-pulse rounded-md" />
        <div className="h-4 w-20 bg-muted/20 animate-pulse rounded-md" />
        <div className="h-4 w-28 bg-muted/20 animate-pulse rounded-md" />
      </div>;
  }
  return <nav className="flex flex-col gap-2">
      {menuItems.map((item, i) => <Link key={item.id} to={item.href || "#"} data-index={i} className="text-sm text-foreground hover:text-foreground transition-colors duration-[var(--duration-medium)]">
          {item.label}
        </Link>)}
    </nav>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer id="footer" className="dark text-foreground section-padding" aria-label="2025 BMW SUV">
      <div className="container mx-auto px-4 max-w-7xl">
        <Separator className="w-full mb-12" />
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8 mb-12">
          {}
          <div className="flex flex-col items-start">
            <img src="https://humane-alien.10web.cloud/wp-content/uploads/2026/02/ChatGPT-Image-Feb-17-2026-07_41_59-PM.png" alt="Phoenix Enterprise TCP" className="h-7" />
            <p className="mt-4 text-sm text-foreground">
              Premium chauffeur service in Los Angeles and surrounding areas.
            </p>
          </div>

          {}
          <div className="flex flex-col">
            <h3 className="font-display text-lg font-semibold mb-4 text-foreground">
              Quick Links
            </h3>
            <MenuProvider menu_id="42">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="flex flex-col">
            <h3 className="font-display text-lg font-semibold mb-4 text-foreground">
              Connect With Us
            </h3>
            <div className="flex flex-wrap gap-4 mb-6">
              <Link to="https://www.facebook.com/reel/1326795919211492" newTab className="p-2 rounded-md border border-white/20 text-foreground hover:text-foreground hover:border-white/40 hover:-translate-y-1 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)]" aria-label="Facebook">
                <Facebook className="size-5" />
              </Link>
              <Link to="https://instagram.com" newTab className="p-2 rounded-md border border-white/20 text-foreground hover:text-foreground hover:border-white/40 hover:-translate-y-1 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)]" aria-label="Instagram">
                <Instagram className="size-5" />
              </Link>
              <Link to="https://youtube.com" newTab className="p-2 rounded-md border border-white/20 text-foreground hover:text-foreground hover:border-white/40 hover:-translate-y-1 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)]" aria-label="YouTube">
                <Youtube className="size-5" />
              </Link>
              <Link to="https://snapchat.com" newTab className="p-2 rounded-md border border-white/20 text-foreground hover:text-foreground hover:border-white/40 hover:-translate-y-1 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)]" aria-label="Snapchat">
                <MessageCircle className="size-5" />
              </Link>
              <Link to="https://spotify.com" newTab className="p-2 rounded-md border border-white/20 text-foreground hover:text-foreground hover:border-white/40 hover:-translate-y-1 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)]" aria-label="Spotify">
                <Radio className="size-5" />
              </Link>
              <Link to="https://linkedin.com" newTab className="p-2 rounded-md border border-white/20 text-foreground hover:text-foreground hover:border-white/40 hover:-translate-y-1 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)]" aria-label="LinkedIn">
                <Linkedin className="size-5" />
              </Link>
              <Link to="https://tiktok.com" newTab className="p-2 rounded-md border border-white/20 text-foreground hover:text-foreground hover:border-white/40 hover:-translate-y-1 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)]" aria-label="TikTok">
                <Music className="size-5" />
              </Link>
            </div>
            <div className="text-sm text-foreground">
              <p>Call or Text: 323-492-6292</p>
              <p className="mt-1">phoenixenerprises@gmail.com</p>
            </div>
          </div>
        </div>

        <Separator className="w-full mb-8" />

        <div className="text-center text-sm text-foreground">
          <p>&copy; {currentYear} Phoenix Enterprise TCP. All rights reserved.</p>
        </div>
      </div>
    </footer>;
}